import { defineStore } from "pinia";
import { computed, ref } from "vue";

const DEFAULT_TITLE = "DataLake Search";

export const usePageTitleStore = defineStore("pageTitle", () => {
  const dynamicTitle = ref(null);
  const routeTitle = ref(DEFAULT_TITLE);

  const pageTitle = computed(() => {
    return dynamicTitle.value || routeTitle.value;
  });

  const setTitle = (title) => {
    dynamicTitle.value = title || routeTitle.value || DEFAULT_TITLE;
    document.title = dynamicTitle.value;
  };

  const resetTitle = () => {
    dynamicTitle.value = null;
    document.title = routeTitle.value;
  };

  const setRouteTitle = (title) => {
    routeTitle.value = title || DEFAULT_TITLE;
    document.title = routeTitle.value;
  };

  return {
    dynamicTitle,
    routeTitle,
    pageTitle,
    setTitle,
    resetTitle,
    setRouteTitle,
  };
});

export function createFormTitle(formData, options = {}) {
  const { maxLength = 50, separator = "-" } = options;

  if (!formData || typeof formData !== "object") {
    return "";
  }

  const parts = [];
  for (const value of Object.values(formData)) {
    if (value && typeof value === "string" && value.trim()) {
      parts.push(value.trim());
    } else if (value && typeof value === "object") {
      for (const subValue of Object.values(value)) {
        if (subValue && typeof subValue === "string" && subValue.trim()) {
          parts.push(subValue.trim());
        }
      }
    }
  }

  if (parts.length === 0) {
    return "";
  }

  const titleParts = parts.slice(0, 2);
  let title = `${titleParts.join(separator)}`;

  if (title.length > maxLength) {
    title = `${title.substring(0, maxLength - 3)}...`;
  }

  return title;
}

export function createSearchTitle(query, options = {}) {
  const { maxLength = 50 } = options;
  let title = query?.trim();
  if (!title) {
    return "";
  }
  title = title.length > maxLength ? `${title.substring(0, maxLength - 3)}...` : title;
  return title;
}
